'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { Modal } from '../Modal/Modal';

interface ContactInfoProps {
  phone: string;
  title: string;
}

import { styles } from './ContactInfo.styles';

export function ContactInfo({ phone, title }: ContactInfoProps) {
  const slots = styles();
  const t = useTranslations();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className={slots.base()}>
        <div className={slots.info()}>
          <p className={slots.title()}>{title}</p>
          <p className={slots.description()}>
            <span className={slots.line()}>{t('contactInfo.callback')}</span>
            <span className={slots.line()}>
              {`${phone} ${t('contactInfo.msg')}`}.
            </span>
          </p>
        </div>
        <UiKitButtonBase
          onClick={() => setIsModalOpen(true)}
          className={slots.button()}
        >
          {t('contactInfo.application')}
        </UiKitButtonBase>
      </div>
      <Modal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
      />
    </>
  );
}
